import * as React from "react";
import { connect } from "react-redux";
import RoutePortal from "../common/RoutePortal";
import RoutePortalLoggedIn from "../common/RoutePortalLoggedIn";
import OnboardingLayout from "./OnboardingLayout";

class OnboardingLayoutRouteLoggedInComp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { component: Component, useOnboardingLayout, setUseOnboardingLayout, ...rest } = this.props;

        return (
            <RoutePortalLoggedIn {...rest} render={(matchProps) => (
                useOnboardingLayout ?
                    <OnboardingLayout sidebarProps={rest.sidebarProps} pageHeading={rest.pageHeading} useOnboardingLayout={useOnboardingLayout}>  <Component {...matchProps} setUseOnboardingLayout={setUseOnboardingLayout} useOnboardingLayout={useOnboardingLayout} /> </OnboardingLayout>
                    : <Component {...matchProps} setUseOnboardingLayout={setUseOnboardingLayout} useOnboardingLayout={useOnboardingLayout}/>

            )} />
        )
    }
}



class OnboardingLayoutRouteComp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {  component: Component, useOnboardingLayout, setUseOnboardingLayout, ...rest } = this.props;

        return (
            <RoutePortal {...rest} render={(matchProps) => (
                useOnboardingLayout ?
                    <OnboardingLayout sidebarProps={rest.sidebarProps} pageHeading={rest.pageHeading} useOnboardingLayout={useOnboardingLayout}>  <Component {...matchProps} setUseOnboardingLayout={setUseOnboardingLayout} useOnboardingLayout={useOnboardingLayout} /> </OnboardingLayout>
                    : <Component {...matchProps} setUseOnboardingLayout={setUseOnboardingLayout} useOnboardingLayout={useOnboardingLayout} />

            )} />
        )
    }
}

const mapStateToProps = (state) => {
    return {       

    };
};

export const OnboardingLayoutRouteLoggedIn =  connect(mapStateToProps )(OnboardingLayoutRouteLoggedInComp);
export const OnboardingLayoutRoute = connect(mapStateToProps)(OnboardingLayoutRouteComp);